<div class="desktop">
  @for (smile of smiles; track smile) {
    <div class="option">
      <div class="smile-wrapper wrapper">
        <span class="smile" [inlineSVG]="'/smiles/' + smile.smileSrc"></span>
      </div>
      <p class="text">{{ smile.text }}</p>
    </div>
  }
</div>

<div class="mobile">
  @for (smile of smiles; track smile) {
    <div class="wrapper">
      <span class="smile" [inlineSVG]="'/smiles/' + smile.smileSrc"></span>
      <p class="text">{{ smile.text }}</p>
    </div>
  }
</div>
